import { getLogger, isLogLevel } from "@imi/utils/logger/index.ts";

const logLevel = import.meta.env.VITE_LOG_LEVEL;

export const logger = getLogger({
  environment: import.meta.env.VITE_ENVIRONMENT,
  level: isLogLevel(logLevel) ? logLevel : "info",
});
